module.exports = __webpack_public_path__ + "static/media/rules.4521bdbb.png";